export const breakpoints = {
  sm: '480px',
  md: '768px',
  lg: '992px',
  xl: '1280px',
  // 2xl is required for custom breakpoints https://v1.chakra-ui.com/docs/styled-system/features/responsive-styles#customizing-breakpoints
  '2xl': '1536px',
} as const;
